import { defineStore } from "pinia";

export const useCartStore = defineStore("cart", {
  state: () => ({
    cart: [], // 购物车数据
    cartTotal: 0,
  }),
  getters: {
    // 计算总价格
    totalPrice(state) {
      return state.cart
        .reduce((total, item) => total + item.quantity * item.priceRMB, 0)
        .toFixed(2);
    },
    cartCount: (state) => state.cart.length, // 统计商品数量
  },
  actions: {
    // 清空购物车
    clearCart() {
      this.cart.splice(0, this.cart.length);
    },
    // 添加商品到购物车
    addToCart(product) {
      const existingItem = this.cart.find((item) => item.productCode === product.productCode);
      if (existingItem) {
        existingItem.quantity++;
      } else {
        this.cart.push({ ...product, quantity: product.quantity || 1 });
      }
    },
    // 添加商品到购物车（别名）
    addToCartProdect(product) {
      this.addToCart(product);
    },
    // 增加商品数量
    increaseQuantity(item) {
      const index = this.cart.findIndex((i) => i.productCode === item.productCode);
      if (index !== -1) {
        this.cart[index].quantity++;
      }
    },
    // 减少商品数量
    decreaseQuantity(item) {
      const index = this.cart.findIndex((i) => i.productCode === item.productCode);
      if (index !== -1 && this.cart[index].quantity > 1) {
        this.cart[index].quantity--;
      }
    },
    // 移除商品
    removeFromCart(item) {
      const index = this.cart.findIndex((i) => i.productCode === item.productCode);
      if (index !== -1) {
        this.cart.splice(index, 1);
      }
    },
    GettotalPrice() {
      return this.cart
        .reduce((total, item) => total + item.quantity * item.priceRMB, 0)
        .toFixed(2);
    },
  },
  // 持久化配置
  persist: {
    key: "cart",
    storage: localStorage,
  },
});

// 数据迁移：清理旧格式残留
if (typeof window !== 'undefined') {
  try {
    const raw = localStorage.getItem('cart');
    if (raw) {
      const parsed = JSON.parse(raw);
      if (parsed.cart && Array.isArray(parsed.cart)) {
        let needsMigrate = false;
        parsed.cart = parsed.cart.map(item => {
          const m = { ...item };
          // 数量 → quantity
          if ('数量' in m && !('quantity' in m)) {
            m.quantity = m['数量'];
            needsMigrate = true;
          }
          delete m['数量'];
          // 货号 → productCode（优先用 productsn 作为值）
          if ('货号' in m) {
            if (!('productCode' in m)) {
              m.productCode = m.productsn || m['货号'];
            }
            delete m['货号'];
            needsMigrate = true;
          }
          // 确保必有 productCode 和 quantity
          if (!('productCode' in m)) {
            m.productCode = m.productsn || m.id || '';
            needsMigrate = true;
          }
          if (!('quantity' in m)) {
            m.quantity = 1;
            needsMigrate = true;
          }
          return m;
        });
        if (needsMigrate) {
          localStorage.setItem('cart', JSON.stringify(parsed));
        }
      }
    }
  } catch (e) {
    localStorage.removeItem('cart');
  }
}
